import { useEffect, useState } from "react";
import { FaPhoneAlt } from "react-icons/fa";

function CallButton() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
   isVisible && (
     <a
      href="tel:+201006602371"
      className="fixed bottom-6 right-6 bg-white text-black p-4 rounded-full shadow-lg hover:bg-black-600 transition-all duration-300 z-50"
    >
      <FaPhoneAlt size={22} />
    </a>
   )
  );
}

export default CallButton;
